var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"detail-wrapper"},[_c('b-col',{attrs:{"sm":12,"id":"visits"}},[_c('visit')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }